interface PurchaseIntentIndicatorProps {
  score: number | null | undefined
  compact?: boolean
}

function normalizeScore(score: number | null | undefined): number {
  if (score === null || score === undefined || !Number.isFinite(score)) {
    return 0
  }
  return Math.max(0, Math.min(1, Number(score)))
}

function intentMeta(score: number): { label: 'Low' | 'Medium' | 'High'; color: string; bg: string } {
  if (score > 0.6) {
    return {
      label: 'High',
      color: 'var(--danger-600)',
      bg: 'var(--danger-100)',
    }
  }
  if (score >= 0.3) {
    return {
      label: 'Medium',
      color: 'var(--warning-600)',
      bg: 'var(--warning-100)',
    }
  }
  return {
    label: 'Low',
    color: 'var(--success-600)',
    bg: 'var(--success-100)',
  }
}

export default function PurchaseIntentIndicator({ score, compact = false }: PurchaseIntentIndicatorProps) {
  const normalized = normalizeScore(score)
  const meta = intentMeta(normalized)

  return (
    <div className={compact ? 'space-y-1' : 'space-y-1.5'}>
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">Purchase Intent</span>
        <span
          className="rounded-full px-2 py-0.5 text-[11px] font-semibold"
          style={{
            backgroundColor: meta.bg,
            color: meta.color,
          }}
        >
          {meta.label}
        </span>
      </div>

      <div className="h-2 overflow-hidden rounded-full bg-slate-200">
        <div
          className="h-full rounded-full transition-all"
          style={{
            width: `${Math.round(normalized * 100)}%`,
            backgroundColor: meta.color,
          }}
        />
      </div>

      {!compact && <div className="text-xs text-slate-500">{normalized.toFixed(2)} / 1.00</div>}
    </div>
  )
}
